import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { BendTrendMode } from '@/models/enums/BendTrendMode';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendTrendModeFilter',
  props: {
    value: { default: BendTrendMode.Chronological }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: BendTrendMode) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: BendTrendMode };





const { t } = useI18n();

// const ids = values(BendTrendMode);
const ids = [BendTrendMode.Chronological, BendTrendMode.Comparative];

function translateBendTrendMode(value: BendTrendMode) {
  return t(`bend_trend_modes.${value}`).toString();
}

const modelValue = computed<BendTrendMode>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const names = computed<string[]>(() =>
  ids.map((id) => translateBendTrendMode(id)),
);

return { __sfc: true,props, emit, t, ids, translateBendTrendMode, modelValue, names, ClickMenu }
}

})